export const ARCHIVE = 'archive'
export const UNSUBSCRIBE = 'unsubscribe'
